import React from "react";
import PropTypes from "prop-types";
import { fetchCall } from "../../service/service_base";
import NewsCard from "../CardPaper/NewsCard";
import { gaEventHit } from '../../service/service_base';
import GenericCarousel from "./GenericCarousel";

class SliderCard extends React.Component {
  state = {
    notes: [],
    menuname: null
  };
  componentDidMount() {
    if (!this.props.isSearching) {
      this._load();
    } else {
      if (this.props.section) {
        this.setState(
          {
            contentElastic: []
          },
          () => {
            this.setState({
              notes: this.props.section.content
            });
          }
        );
      }
    }
  }

  _load = () => {
    fetchCall("POST", "/synthesis/getcontentpublish", {
      sectionId: this.props.section.sec_id,
      menuId: this.props.idMenuSelected
    })
      .then(response => {
        let sm = JSON.parse(localStorage.getItem("session_menu"))

        let menu = [];
        if (Array.isArray(sm)) {
          menu = sm.find(x => x.menu_id === this.props.idMenuSelected);
        }
        const menuname = menu;

        this.setState({ notes: response.data, menuname: menuname.menu_name });
      })
      .catch(err => console.log(err));
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.isSearching && nextProps.section) {
      this.setState({
        notes: nextProps.section.content
      });
    }
  }

  sendEvent = () => {
    if (this.state.menuname)
      gaEventHit(this.state.menuname, this.props.section.sec_name)
  }

  renderNewsCard = (item, index) => {
    const { isSearching, section, noImage, noKicker } = this.props;
    
    if (item.cont_key) {
      item.cont_imagePath = item.cont_key;
    }
    
    return (
      <NewsCard
        kicker={noKicker ? false : item.cont_program}
        title={item.cont_name}
        description={item.cont_description}
        notes={item.cont_notas}
        // image={noImage ? false : item.cont_imagePath || item.cont_key}
        attachment={isSearching ? item.cont_attachment : item.cont_attachmentKey}
        publish_date={item.publish_date}
        colorTitle={section.sec_color}
        sendEvent={this.sendEvent}
      />
    );
  }

  render() {
    const { section, isWhiteBackground } = this.props;

    return (
      <GenericCarousel
        items={this.state.notes}
        renderItem={this.renderNewsCard}
        isWhiteBackground={isWhiteBackground}
      />
    );
  }
}

SliderCard.propTypes = {
  section: PropTypes.object.isRequired,
  idMenuSelected: PropTypes.any,
  isSearching: PropTypes.bool,
  noImage: PropTypes.string,
  noKicker: PropTypes.string,
  isWhiteBackground: PropTypes.bool,
};

export default SliderCard;
